/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StackFileTypeEnumDto {
    FRONT_IMAGE = 'FrontImage',
    BACK_IMAGE = 'BackImage',
    CLOSEUP_IMAGE = 'CloseupImage',
    FRONT_IMAGE_ANNOTATIONS = 'FrontImageAnnotations',
    BACK_IMAGE_ANNOTATIONS = 'BackImageAnnotations',
    CLOSEUP_IMAGE_ANNOTATIONS = 'CloseupImageAnnotations',
    REPORT = 'Report',
    LDAT = 'LDAT',
    XML = 'XML',
    CSV = 'Csv',
    HESSEN_ELDAT = 'HessenELDAT',
    OTHER = 'Other',
}